import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import BaseClickable from 'components/ui/BaseClickable';
import Typo from 'components/ui/Typo';
import { accessibilityParamsStore } from 'stores/root';

import s from './LegalItem.module.scss';

export type LegalItemProps = {
  url: string;
  text: string;
};

const LegalItem: React.FC<LegalItemProps> = ({ url, text }) => {
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <BaseClickable element="a" href={url}>
      <Typo className={cn(s.legalItem, isAccessibilityMode && s.legalItem_accessibility)} element="p" view="body-3">
        {text}
      </Typo>
    </BaseClickable>
  );
};

export default observer(LegalItem);
